import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  PageHeader,
  Table,
  Typography,
  message,
  Progress,
  Spin,
  Button,
  Tooltip,
  Tag,
} from "antd";
import { FilePdfOutlined } from "@ant-design/icons";
import TiepAvailableLiabilitySearch from "./AvailableLiabilitySearch";
import { Link } from "react-router-dom";
import Page from "_components/Page";
import { stockReceiptService, stockIssueService } from "_services";
import { CurrencyFormatter } from "_helpers/formatters";
import moment from "moment";

function TiepAvailableLiabilities({ history }) {
  const [loading, setLoading] = useState(true);
  const [searchLoading, setSearchLoading] = useState(true);
  const [error, setError] = useState(null);
  const [stores, setStores] = useState([]);
  const [stockTypes, setStockTypes] = useState([]);
  const [items, setItems] = useState([]);
  const [searchQuery, setSearchQuery] = useState([]);
  const [liabilityAgingData, setLiabilityAgingData] = useState(null);
  const [searchParams, setSearchParams] = useState("");
  const [genearatingExcel, setGeneratingExcel] = useState(false);

  const { Title } = Typography;
  const precision = 3;

  useEffect(() => {
    getAvailableLiabilities(searchParams);
  }, [searchParams]);

  const getAvailableLiabilities = async (searchParams) => {
    setLoading(true);
    try {
      const result = await stockReceiptService.stockReceiptAvailabilitySearch(
        searchParams
      );
      setLiabilityAgingData(result.content);
    } catch (error) {
      message.error(error ?? "no data");
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  const getColumns = () => {
    const columns = [];
    columns.push({
      title: "Cus.Dec.No#",
      dataIndex: ["customRefNumber"],
      key: "customRefNumber",
      width: "8%",
      render: (text) => <Tag color="#13c2c2">{text}</Tag>,
    });

    columns.push({
      title: "Import Type",
      dataIndex: ["receiptType"],
      key: "receiptType",
      render: (text) => (
        <Tag color={text === "LOCAL" ? "orange" : "blue"}>
          {text === "LOCAL" ? "INDIRECT" : "DIRECT"}
        </Tag>
      ),
      width: "8%",
    });

    columns.push({
      title: "Liability",
      key: "totalLiabilityAmount",
      dataIndex: ["totalLiabilityAmount"],
      align: "right",
      render: (text, record) => CurrencyFormatter(text ?? 0),
    });

    columns.push({
      title: "Remaining Liability",
      key: "availableLiabilityAmount",
      dataIndex: ["availableLiabilityAmount"],
      align: "right",
      render: (text, record) => CurrencyFormatter(text ?? 0),
    });

    columns.push({
      title: "VAT",
      dataIndex: ["totalVatAmount"],
      key: "totalVatAmount",
      align: "right",
      ellipsis: {
        showTitle: false,
      },
      render: (text, record) => CurrencyFormatter(text ?? 0),
    });

    columns.push({
      title: "Writeoff %",
      key: "Completion",
      dataIndex: ["Completion"],
      width: "20%",
      render: (text, record) => {
        const percentageAvailable =
          ((record?.totalLiabilityAmount - record?.availableLiabilityAmount) /
            record?.totalLiabilityAmount) *
          100;

        const roundedPercentage = Math.round(percentageAvailable);

        return (
          <Progress
            percent={roundedPercentage}
            percentPosition={{ align: "center", type: "inner" }}
            strokeColor="#77dd77"
            status="active"
          />
        );
      },
    });
    return columns;
  };

  const handleSearchResults = (searchParamString) => {
    setSearchParams(searchParamString);
  };

  const onCancel = () => {
    history.push("/");
  };

  const handleExportExcel = async () => {
    try {
      setGeneratingExcel(true);
      const response =
        await stockReceiptService.exportExcelOfAvialableLiability(searchQuery);
      const url = window.webkitURL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `Available-Liability_Report_${moment(new Date()).format(
          "YYYY-MM-DD"
        )}.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
    } finally {
      setGeneratingExcel(false);
    }
  };

  const getActionButtons = () => {
    let buttons = [];

    buttons.push(
      <Tooltip
        key="export-excel-tooltip"
        placement="topLeft"
        title="EXPORT EXCEL"
      >
        <Button
          key="export-excel"
          icon={<FilePdfOutlined />}
          onClick={(e) => {
            e.preventDefault();
            handleExportExcel();
          }}
          loading={genearatingExcel}
        >
          Export Excel
        </Button>
      </Tooltip>
    );

    buttons.push(
      <Button key="2" htmlType="button" onClick={onCancel}>
        Cancel
      </Button>
    );

    return buttons;
  };

  return (
    <>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/reports">Reports</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Available Liabilities</Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner error={error}>
          <TiepAvailableLiabilitySearch
            showSearchLoading={setLoading}
            onSearchResults={handleSearchResults}
            addresses={stores}
            stockTypes={stockTypes}
          />

          {/*
            {!dateFilter && (
              <Title level={5} style={{ marginTop: 20 }}>
                As of: {moment().format("YYYY-MM-DD")}
              </Title>
            )}
            {dateFilter && (
              <Title level={5} style={{ marginTop: 20 }}>
                As of: From:{moment(fromDate).format("YYYY-MM-DD")} - To:
                {moment(toDate).format("YYYY-MM-DD")}
              </Title>
            )}

            <div
              style={{
                background: "#ECECEC",
                padding: "15px",
                marginBottom: 15,
              }}
            >
              {liabilityAgingData && (
                <Row gutter={24}>
                  <Col span={4}>
                    <Card
                      style={{
                        justifyItems: "center",
                        borderRadius: "20px",
                      }}
                    >
                      <Statistic
                        title="VAT"
                        precision={2}
                        value={liabilityAgingData
                          .map((item) => item.totalVat ?? 0)
                          .reduce((prev, next) => prev + next, 0)}
                        valueStyle={{ color: "#3f8600" }}
                      />
                    </Card>
                  </Col>

                  <Col span={4}>
                    <Card
                      style={{
                        justifyItems: "center",
                        borderRadius: "20px",
                      }}
                    >
                      <Statistic
                        title="Liability"
                        precision={2}
                        value={liabilityAgingData
                          .map((item) => item.totalDuty)
                          .reduce((prev, next) => prev + next, 0)}
                        valueStyle={{ color: "#3f8600" }}
                      />
                    </Card>
                  </Col>

                  <Col span={4}>
                    <Card
                      style={{
                        justifyItems: "center",
                        borderRadius: "20px",
                      }}
                    >
                      <Statistic
                        title="CID"
                        precision={2}
                        value={liabilityAgingData
                          .map((item) => item.totalCid ?? 0)
                          .reduce((prev, next) => prev + next, 0)}
                        valueStyle={{ color: "#3f8600" }}
                      />
                    </Card>
                  </Col>

                  <Col span={4}>
                    <Card
                      style={{
                        justifyItems: "center",
                        borderRadius: "20px",
                      }}
                    >
                      <Statistic
                        title="EID"
                        precision={2}
                        value={liabilityAgingData
                          .map((item) => item.totalEid ?? 0)
                          .reduce((prev, next) => prev + next, 0)}
                        valueStyle={{ color: "#3f8600" }}
                      />
                    </Card>
                  </Col>
                  <Col span={4}>
                    <Card
                      style={{
                        justifyItems: "center",
                        borderRadius: "20px",
                      }}
                    >
                      <Statistic
                        title="PAL"
                        precision={2}
                        value={liabilityAgingData
                          .map((item) => item?.totalPal ?? 0)
                          .reduce((prev, next) => prev + next, 0)}
                        valueStyle={{ color: "#3f8600" }}
                      />
                    </Card>
                  </Col>
                  <Col span={4}>
                    <Card
                      style={{
                        justifyItems: "center",
                        borderRadius: "20px",
                      }}
                    >
                      <Statistic
                        title="SSL"
                        precision={2}
                        value={liabilityAgingData
                          .map((item) => item?.totalSsl ?? 0)
                          .reduce((prev, next) => prev + next, 0)}
                        valueStyle={{ color: "#3f8600" }}
                      />
                    </Card>
                  </Col>
                </Row>
              )}
            </div> */}

          <Spin spinning={loading} tip="Loading" size="large">
            {/* {liabilityAgingData && ( */}
            <Table
              bordered
              size="small"
              columns={getColumns()}
              dataSource={liabilityAgingData}
              pagination={false}
              expandable={true}
            />
            {/* )} */}
          </Spin>
        </Page>
      </PageHeader>
    </>
  );
}

export default TiepAvailableLiabilities;
